package io.horion.cv.components.widgets

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaPlus
import com.varabyte.kobweb.silk.components.text.SpanText
import io.horion.cv.models.NewMenuItemData
import io.horion.cv.models.items
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import kotlinx.browser.document
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.dom.Div
import org.w3c.dom.HTMLElement
import org.w3c.dom.events.Event


private const val ATTR_NEW_DROPDOWN = "data-new-dropdown"

@Composable
fun NewItemDropdown(
    onNavigate: (String) -> Unit,
    modifier: Modifier = Modifier
) {

    var isOpen by remember { mutableStateOf(false) }

    DisposableEffect(Unit) {

        val closeMenu = {
            isOpen = false
        }

        val clickListener: (Event) -> Unit = { event ->
            val target = event.target as? HTMLElement

            val insideDropdown =
                target?.closest("[$ATTR_NEW_DROPDOWN]") != null

            if (!insideDropdown) {
                isOpen = false
            }
        }

        val externalActionListener: (Event) -> Unit = {
            closeMenu()
        }

        document.addEventListener("click", clickListener, true)
        document.addEventListener("scroll", externalActionListener, true)
        document.addEventListener("wheel", externalActionListener, true)
        document.addEventListener("touchmove", externalActionListener, true)

        onDispose {
            document.removeEventListener("click", clickListener, true)
            document.removeEventListener("scroll", externalActionListener, true)
            document.removeEventListener("wheel", externalActionListener, true)
            document.removeEventListener("touchmove", externalActionListener, true)
        }
    }

    Div(
        attrs = Modifier
            .fillMaxWidth()
            .position(Position.Relative)
            .toAttrs {
                attr(ATTR_NEW_DROPDOWN, "true")
            }
    ) {
        Column(
            modifier = modifier.fillMaxWidth()
        ) {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(44.px)
                    .backgroundColor(Colors.White)
                    .borderRadius(
                        topLeft     = 8.px,
                        topRight    = 8.px,
                        bottomLeft  = if (isOpen) 0.px else 8.px,
                        bottomRight = if (isOpen) 0.px else 8.px
                    )
                    .cursor(Cursor.Pointer)
                    .onClick { isOpen = !isOpen }
                    .gap(8.px),
                verticalAlignment    = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.Center
            ) {
                /*Image(
                    src = "/add_27dp_666666.svg",
                    description = "Nouveau",
                    modifier = Modifier.size(25.px)
                )*/
                FaPlus(
                    modifier = Modifier.fontSize(20.px)
                        .color(Color.rgb(0xb5, 0xb5, 0xb5))
                )
                SpanText(
                    text = "Nouveau",
                    modifier = Modifier
                        .fontFamily(INTER)
                        .fontSize(20.px)
                        .fontWeight(FontWeight.Medium)
                        .color(Colors.DarkBlue)
                )
            }

            if (isOpen) {
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .backgroundColor(Colors.White)
                        .borderRadius(
                            topLeft     = 0.px,
                            topRight    = 0.px,
                            bottomLeft  = 8.px,
                            bottomRight = 8.px
                        )
                        .border(1.px, LineStyle.Solid, Colors.lineBorder)
                ) {
                    items.forEachIndexed { index, item ->

                        NewDropdownItem(
                            item    = item,
                            onClick = {
                                isOpen = false
                                onNavigate(item.route)
                            }
                        )

                        if (index < items.lastIndex) {
                            Box(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .height(1.px)
                                    .backgroundColor(Colors.lineBorder)
                            )
                        }
                    }
                }
            }
        }
    }
}

@Composable
private fun NewDropdownItem(
    item: NewMenuItemData,
    onClick: () -> Unit
) {
    var hovered by remember { mutableStateOf(false) }

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .height(52.px)
            .padding(leftRight = 16.px)
            .backgroundColor(if (hovered) Colors.PriceGray else Colors.White)
            .cursor(Cursor.Pointer)
            .onMouseEnter { hovered = true }
            .onMouseLeave { hovered = false }
            .onClick { onClick() }
            .gap(14.px),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Image(
            src         = item.iconSrc,
            description = item.label,
            modifier    = Modifier.size(20.px)
        )
        SpanText(
            text     = item.label,
            modifier = Modifier
                .fontFamily(INTER)
                .fontSize(16.px)
                .fontWeight(FontWeight.Normal)
                .color(Colors.Black)
        )
    }
}